import React, { useEffect } from 'react'
import { Text } from '@mantine/core'

interface NoChancesViewProps {
  pointsNeeded: number
}

const noChancesKeyframes = `
  @keyframes fadeInUp {
    0% {
      transform: translateY(20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes breathe {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.02);
    }
  }

  @keyframes gradientShift {
    0%, 100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }

  @keyframes coinBounce {
    0%, 100% {
      transform: translateY(0px) rotate(0deg);
    }
    25% {
      transform: translateY(-8px) rotate(5deg);
    }
    75% {
      transform: translateY(-4px) rotate(-3deg);
    }
  }
`

const NoChancesView: React.FC<NoChancesViewProps> = ({ pointsNeeded }) => {
  useEffect(() => {
    const style = document.createElement('style')
    style.textContent = noChancesKeyframes
    document.head.appendChild(style)
    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style)
      }
    }
  }, [])

  return (
    <div
      style={{
        margin: '0 auto',
        width: '90%',
        height: 225,
        border: '6px solid transparent',
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `
          linear-gradient(135deg, #FFE4E1 0%, #FFD1D1 50%, #FFBDBD 100%),
          linear-gradient(45deg, #FF5A5A, #FF8E8E, #FFB6B6, #FF5A5A)
        `,
        backgroundSize: '100% 100%, 300% 300%',
        backgroundClip: 'padding-box, border-box',
        animation: 'fadeInUp 0.8s ease-out, breathe 3s ease-in-out infinite 1s',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: `
          0 8px 32px rgba(255, 90, 90, 0.15),
          inset 0 2px 4px rgba(255, 255, 255, 0.3)
        `,
      }}
    >
      {/* 装饰性背景元素 */}
      <div
        style={{
          position: 'absolute',
          top: 20,
          left: 20,
          width: 30,
          height: 30,
          background: 'radial-gradient(circle, rgba(255, 90, 90, 0.3) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'coinBounce 2s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: 30,
          right: 30,
          width: 25,
          height: 25,
          background: 'radial-gradient(circle, rgba(255, 90, 90, 0.2) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'coinBounce 2s ease-in-out infinite 0.5s',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          right: 15,
          width: 20,
          height: 20,
          background: 'radial-gradient(circle, rgba(255, 90, 90, 0.25) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'coinBounce 2s ease-in-out infinite 1s',
        }}
      />

      {/* 内容区域 */}
      <div
        style={{
          textAlign: 'center',
          padding: '20px',
          background: 'rgba(255, 255, 255, 0.9)',
          borderRadius: 12,
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.5)',
          boxShadow: '0 4px 16px rgba(255, 90, 90, 0.1)',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <div style={{ marginBottom: 12 }}>
          <Text
            size="lg"
            fw={700}
            style={{
              color: '#FF5A5A',
              fontSize: 18,
              marginBottom: 8,
              textShadow: '0 1px 2px rgba(255, 90, 90, 0.2)',
            }}
          >
            💰 积分不足
          </Text>
        </div>

        <Text
          size="md"
          fw={600}
          style={{
            color: '#AD7777',
            fontSize: 16,
            lineHeight: 1.4,
            marginBottom: 8,
          }}
        >
          还差{' '}
          <span
            style={{
              color: '#FF5A5A',
              fontWeight: 800,
              fontSize: 18,
              textShadow: '0 1px 2px rgba(255, 90, 90, 0.3)',
            }}
          >
            {pointsNeeded}
          </span>{' '}
          积分可以抽奖
        </Text>

        <Text
          size="sm"
          style={{
            color: '#B88888',
            fontSize: 14,
            marginTop: 4,
          }}
        >
          🎯 快去赚取更多积分吧！
        </Text>
      </div>
    </div>
  )
}

export default NoChancesView
